import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/subsidiaries'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  subsidiary: {},
  subsidiaries: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  subsidiary: state => state.subsidiary,
  subsidiaries: state => state.subsidiaries
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_SUBSIDIARY = 'REQUEST_GET_SUBSIDIARY'
const RECEIVE_GET_SUBSIDIARY = 'RECEIVE_GET_SUBSIDIARY'

const REQUEST_CREATE_SUBSIDIARY = 'REQUEST_CREATE_SUBSIDIARY'
const RECEIVE_CREATE_SUBSIDIARY = 'RECEIVE_CREATE_SUBSIDIARY'

const REQUEST_UPDATE_SUBSIDIARY = 'REQUEST_UPDATE_SUBSIDIARY'
const RECEIVE_UPDATE_SUBSIDIARY = 'RECEIVE_UPDATE_SUBSIDIARY'

const REQUEST_DELETE_SUBSIDIARY = 'REQUEST_DELETE_SUBSIDIARY'
const RECEIVE_DELETE_SUBSIDIARY = 'RECEIVE_DELETE_SUBSIDIARY'

const UPDATE_SUBSIDIARY_PROPERTY = 'UPDATE_SUBSIDIARY_PROPERTY'

const REQUEST_GET_SUBSIDIARIES = 'REQUEST_GET_SUBSIDIARIES'
const RECEIVE_GET_SUBSIDIARIES = 'RECEIVE_GET_SUBSIDIARIES'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getSubsidiaries ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting subsidiaries', { root: true })
    commit(REQUEST_GET_SUBSIDIARIES)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveSubsidiaries', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting subsidiaries', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting subsidiaries', { root: true })
        return Promise.reject(error)
      })
  },
  async getSubsidiary ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting subsidiary', { root: true })
    commit(REQUEST_GET_SUBSIDIARY, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveSubsidiary', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting subsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting subsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async createSubsidiary ({ commit, dispatch }, data) {
    dispatch('wait/start', 'creating subsidiary', { root: true })
    commit(REQUEST_CREATE_SUBSIDIARY, data)
    return axios.post(`${endpointConfig.url}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveSubsidiary', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating subsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating subsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async updateSubsidiary ({ commit, dispatch }, [ id, data ]) {
    dispatch('wait/start', 'updating subsidiary', { root: true })
    commit(REQUEST_UPDATE_SUBSIDIARY, id)
    return axios.put(`${endpointConfig.url}/${id}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveSubsidiary', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating subsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating subsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteSubsidiary ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting subsidiary', { root: true })
    commit(REQUEST_DELETE_SUBSIDIARY, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_SUBSIDIARY, response.data)
        dispatch('wait/end', 'deleting subsidiary', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting subsidiary', { root: true })
        return Promise.reject(error)
      })
  },
  receiveSubsidiary ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_SUBSIDIARY`, extract(json))
    return json.data
  },
  receiveSubsidiaries ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_SUBSIDIARIES`, extract(json))
    return json.data
  },
  updateSubsidiaryProperty ({ commit, dispatch }, [ property, value ]) {
    commit(`UPDATE_SUBSIDIARY_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_GET_SUBSIDIARY] (state, json) {
    state.subsidiary = json
  },
  [REQUEST_CREATE_SUBSIDIARY] (state, json) {
  },
  [RECEIVE_CREATE_SUBSIDIARY] (state, json) {
    state.subsidiary = json
  },
  [REQUEST_UPDATE_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_UPDATE_SUBSIDIARY] (state, json) {
    state.subsidiary = json
  },
  [REQUEST_DELETE_SUBSIDIARY] (state, id) {
  },
  [RECEIVE_DELETE_SUBSIDIARY] (state, json) {
    state.subsidiary = {}
  },
  [UPDATE_SUBSIDIARY_PROPERTY] (state, [ property, value ]) {
    state.subsidiary[property] = value
  },
  [REQUEST_GET_SUBSIDIARIES] (state) {
  },
  [RECEIVE_GET_SUBSIDIARIES] (state, json) {
    state.subsidiaries = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
